




































































































































import { Component, Vue, PropSync, Prop, Watch } from "vue-property-decorator";
import store from "@/store";
import _ from "underscore";
// types
import { Category as TaxonomyCategory } from "@/types/taxonomy/category";
import { LogVariable } from "@/types/logVariable";
import { ExtendedVessel } from "@/types/vessel";
import { FeatureAttribute } from "@/types/cds/featureAttribute";
import { LogVariableTaxon } from "@/types/logVariableTaxon";

// components
import LogVariablesDialog from "@/components/widgets/LogVariablesDialog.vue";
import CdsFeatureSelectDialog from "@/components/CdsFeatureSelectDialog.vue";

// modules
import { getModule } from "vuex-module-decorators";
import TaxonomyModule from "@/store/clients/Taxonomy.module";
import LogVariablesModule from "@/store/clients/LogVariables.module";
import CdsModule from "@/store/clients/Cds.module";

const Taxonomy = getModule(TaxonomyModule, store);
const LogVariables = getModule(LogVariablesModule, store);
const Cds = getModule(CdsModule, store);

@Component({
  components: {},
})
export default class VesselFeatureLogVariableSelect extends Vue {
  @Prop() value!: LogVariable | null;
  @Prop({ required: true }) vessel!: ExtendedVessel;
  @Prop({ default: false }) disabled!: boolean;
  @Prop({ default: false }) loading!: boolean;
  @Prop({ required: true, default: "logVariable" }) type!: string; // "logVariable" | "cdsFeature"
  @Prop({ default: "Select Feature or Log Variable" }) placeholder!: string;

  //  @Data
  searchQuery: string = "";
  isVesselFeaturesLogVariablesLoaded: boolean = false;
  vesselFeatureList: FeatureAttribute[] = [];

  //  @Watchers

  //  @Getters
  get selectedFeatureLogVariable(): LogVariable | null {
    return this.value;
  }
  set selectedFeatureLogVariable(val: LogVariable | null) {
    this.$emit("input", val);
  }

  get filteredFeatureLogVariables(): (LogVariable | FeatureAttribute)[] {
    if (!this.searchQuery) {
      return this.vesselFeaturesLogVariables || [];
    }
    const query = this.searchQuery.toLowerCase();
    return (this.vesselFeaturesLogVariables ?? []).filter(variable => variable.name.toLowerCase().includes(query));
  }

  get vesselFeaturesLogVariables(): LogVariable[] | FeatureAttribute[] | undefined {
    if (this.type !== "cdsFeature") return LogVariables.logVariableByVesselId(this.vessel.id) ?? [];
    return this.vesselFeatureList ?? [];
  }

  get isDataLoading(): boolean {
    return !this.isVesselFeaturesLogVariablesLoaded || this.loading;
  }

  get menuProps(): object {
    return {
      maxHeight: "320",
      contentClass: "dfi-select__content dense",
      transition: "slide-y-transition",
      openOnHover: false,
      bottom: true,
      offsetY: true,
    };
  }

  //  @Methods
  async fetchFeaturesLogVariablesByVesselId() {
    if (!this.vesselFeaturesLogVariables?.length) {
      this.isVesselFeaturesLogVariablesLoaded = true;
    }
    if (this.type === "cdsFeature") {
      this.vesselFeatureList = await Cds.fetchVesselFeatures(this.vessel.id);
    } else {
      await LogVariables.fetchAllLogVariablesByVesselId(this.vessel.id);
    }
    this.isVesselFeaturesLogVariablesLoaded = true;
  }

  onFeatureLogVariableChange(selected: LogVariable | null) {
    this.$emit("change", selected);
  }

  unitName(item: LogVariable): string {
    return item.unit?.name || "N/A";
  }

  //  @Hooks
  mounted() {
    this.fetchFeaturesLogVariablesByVesselId();
  }
}
